import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import AuthLayout from './AuthLayout';
import { authService } from '../../services/authService';

const SignOutSuccessPage: React.FC = () => {
  // Clear auth when this component mounts
  React.useEffect(() => {
    authService.logout();
  }, []);

  return (
    <AuthLayout title="Successfully signed out" subtitle="You have been securely logged out of your account">
      <div className="text-center space-y-6">
        {/* Success Icon */}
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 dark:bg-green-900">
          <CheckCircle className="h-8 w-8 text-green-600 dark:text-green-400" />
        </div>

        {/* Success Message */}
        <div className="space-y-3">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white">
            You're all set!
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Your session has been terminated and all data has been cleared from this device.
          </p>
        </div>

        {/* Actions */}
        <div className="space-y-3">
          <Link
            to="/login"
            className="
              w-full flex justify-center py-2 px-4 border border-transparent 
              text-sm font-medium rounded-md text-white bg-black hover:bg-gray-800 
              focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500
              dark:bg-gray-900 dark:hover:bg-gray-800 dark:focus:ring-gray-400
              transition-colors duration-200
            "
          >
            Sign in again
          </Link>

          <Link
            to="/register"
            className="
              w-full flex justify-center py-2 px-4 border border-gray-300 dark:border-gray-600
              text-sm font-medium rounded-md text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800
              hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 
              focus:ring-offset-2 focus:ring-gray-500 transition-colors duration-200
            "
          >
            Create new account
          </Link>
        </div>

        {/* Security Note */}
        <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-3">
          <p className="text-xs text-blue-800 dark:text-blue-200">
            <strong>Security tip:</strong> Always sign out when using shared or public computers
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default SignOutSuccessPage;
